import { Level2 } from '../StyledOl';

const Testing = () => (
  <li>
    TESTING (IF APPLICABLE)
    <Level2>
      <li>
        It shall be the Contractor&rsquo;s responsibility to conduct tests on the Goods and/or
        Service in accordance with the manufacturer&rsquo;s specifications and/or Specifications
        and/or such other test procedures which are capable of demonstrating whether the Goods
        and/or Service complies in all respects with the Specifications and satisfy itself that the
        Goods and/or Service is safe, reliable and functional and performs in accordance with the
        Specifications either before or after delivery of the Goods and/or Service (as may be
        appropriate) to LINK (&ldquo;
        <strong>Acceptance Tests</strong>&rdquo;). Such test results shall be documented and
        submitted to LINK if requested by LINK.
      </li>
      <li>
        Upon the Contractor&rsquo;s delivery of the&nbsp;Goods and/or Service, LINK shall be
        entitled to carry out tests to determine if the Goods and/or Service conforms to the
        Specifications and the technical, functional, performance and other requirements and
        specifications required to be met by LINK (&ldquo;
        <strong>LINK</strong>&nbsp;
        <strong>Acceptance Tests</strong>&rdquo;). LINK shall be entitled to conduct, as part of
        LINK Acceptance Tests, any and all tests as determined in its sole discretion as well as to
        determine and/or adopt such procedures, data or criteria (&ldquo;
        <strong>Test Criteria</strong>&rdquo;) that it deems necessary for such tests, to
        demonstrate that the Goods and/or Service, whether in whole or in part, complies in all
        respects with the Specifications.
      </li>
      <li>
        LINK shall be entitled to direct and request the Contractor to prepare the Test Criteria for
        its approval and the Contractor shall comply with such direction or request. The Contractor
        shall be responsible for the testing of the Goods and/or Service and shall perform the
        Acceptance Tests, or where requested by LINK, assist LINK to carry out LINK Acceptance
        Tests. The Contractor shall perform any additional test(s) requested for by LINK during the
        testing of the Goods and/or Service where the Contractor&rsquo;s recommended test(s) are, in
        the opinion of LINK, inadequate at no additional charge to LINK. The Contractor shall
        furnish all relevant test reports to LINK after the completion of each test, and LINK shall
        be entitled to review all relevant tests results.
      </li>
      <li>
        Any Acceptance Test or&nbsp;LINK Acceptance Test shall only be successfully completed if it
        conclusively demonstrates to LINK that the Goods and/or Service comply fully with the Test
        Criteria and is in all respects in accordance with the Specifications.
      </li>
      <li>
        LINK reserves the right to conduct the Acceptance Test or LINK Acceptance Test but shall not
        be obliged to do so.
      </li>
    </Level2>
  </li>
);

export default Testing;
